export default {
  addToCart: {
    id: 'product_page_add_to_cart',
    defaultMessage: 'Add to cart',
  },
  originalPriceDisplay: {
    id: 'product_page_add_to_cart_original_price_display',
    defaultMessage: '{price} new',
  },
}
